import React, { useEffect, useState, useRef } from "react";
import { Paper } from "@material-ui/core";
import { baseUrl, config } from "../../../../services/config";
import { Spinner, Table } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import { upperCase } from "lodash";
import { useAlert } from "react-alert";
import { DownloadTableExcel } from "react-export-table-to-excel";

const ChallanReceiveUserWise = () => {
  const [data, setData] = useState([]);
  const [currentDate, setCurrentDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [loading, setLoading] = useState(false);
  const [selectedbankcateogry, setselectedbankcateogry] = useState("");
  const [allbanks, setallbanks] = useState([]);
  const [allsubaccounts, setallsubaccounts] = useState([]);
  const [selectedbank, setselectedbank] = useState("");
  const [wholeBankCat, setWholeBankCat] = useState([]);
  const [wholeBank, setWholeBank] = useState({});

  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const exportTable = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  let authtoken = localStorage.getItem("userToken");
  const getBranchUrl = localStorage.getItem("branchUrl");

  const [isVisible, setIsVisible] = useState(false);
  const alert = useAlert();
  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);
  const [grandTotalAmount, setGrandTotalAmount] = useState(0);

  useEffect(() => {
    getAllBanks();
    getSettingData();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data.payload);
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllBanks = () => {
    fetch(`${baseUrl}/bank_account_category`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        //  setinitialloading(false)
        console.log(data, "fetch data ");
        setallbanks(data.payload);
        if (selectedbankcateogry != "") {
          let anserr = data.payload.filter(
            (item) => item.id == selectedbankcateogry
          );

          if (anserr.length != 0) {
            setallsubaccounts([...anserr[0].bank_accounts]);
          } else {
            setallsubaccounts([]);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDateChange = () => {
    if (currentDate == "") {
      alert.error("Month Not Set");
      return false;
    }

    const data = {
      date: currentDate,
      bank_account_id: selectedbank,
    };

    setLoading(true);
    setIsVisible(false);
    fetch(`${baseUrl}/daily-scroll-user-received-wise`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        console.log(data);

        if (data.metadata) {
          setIsVisible(true);
          if (data.metadata.success) {
            let grandTotal = 0;
            data.payload.map((item) => {
              grandTotal += parseInt(item.total_paid);
            });
            setGrandTotalAmount(parseInt(grandTotal));
            setData(data.payload);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  //for print
  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);
  const todayDate = () => {
    let d = new Date();
    var curr_moth = ("0" + (d.getMonth() + 1)).slice(-2);
    var curr_date = ("0" + d.getDate()).slice(-2);
    let newdate = `${d.getFullYear()}-${curr_moth}-${curr_date}`;
    return newdate;
  };

  const handleBankChange = (e) => {
    const selectedValue = e.target.value;
    setselectedbank(selectedValue);

    if (selectedValue === "") {
      setWholeBank([]);
    } else {
      const result = allsubaccounts.find((item) => item.id == selectedValue);
      setWholeBank(result);
    }
  };

  const getMonthName = (date) => {
    const monthNames = [
      "January", // index 0
      "February", // index 1
      "March", // index 2
      "April", // index 3
      "May", // index 4
      "June", // index 5
      "July", // index 6
      "August", // index 7
      "September", // index 8
      "October", // index 9
      "November", // index 10
      "December", // index 11
    ];
    const d = new Date(date);

    return `${monthNames[d.getMonth()]}, ${d.getDate()} ${d.getFullYear()}`;
  };

  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row">
          <div className="col-md-3">
            <label className="form-control-label">
              <b>
                Select Date{" "}
                <span style={{ color: "red", fontSize: 12 }}>*</span>
              </b>
            </label>
            <input
              value={currentDate}
              className="form-control"
              onChange={(e) => setCurrentDate(e.target.value)}
              type="date"
            />
          </div>

          <div className="row col-md-3">
            <label className="form-control-label">
              <b>
                Select Bank{" "}
                <span style={{ color: "red", fontSize: 12 }}>*</span>
              </b>
            </label>
            <select
              className="form-select form-control"
              name="sub_account_id"
              value={selectedbankcateogry}
              onChange={(e) => {
                setselectedbank("");
                setselectedbankcateogry(e.target.value);
                let anserr = allbanks.filter(
                  (item) => item.id == e.target.value
                );
                setWholeBankCat(anserr);
                if (anserr.length != 0) {
                  setallsubaccounts([...anserr[0].bank_accounts]);
                } else {
                  setallsubaccounts([]);
                }
              }}
              style={{ backgroundColor: "white" }}
              aria-label="Default select example"
            >
              <option value="">Select...</option>
              {allbanks.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.title}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-control-label">
              <b>
                Select Bank Branch<span style={{ color: "red" }}> *</span>
              </b>
            </label>
            <select
              className="form-select form-control"
              name="sub_account_id"
              value={selectedbank}
              onChange={handleBankChange}
              style={{ backgroundColor: "white" }}
              aria-label="Default select example"
            >
              <option value="">Select...</option>
              {allsubaccounts.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.bank_name}&nbsp;&nbsp;{`(${item.account_head})`}
                </option>
              ))}
            </select>
          </div>

          <div className="d-flex col-md-3 mt-7">
            <button className="btn btn-primary mx-2" onClick={handleDateChange}>
              Show
            </button>

            {data?.length > 0 ? (
              <ReactToPrint
                documentTitle={`Challan Receive User Wise`}
                pageStyle="auto"
                onAfterPrint={handleAfterPrint}
                onBeforeGetContent={handleOnBeforeGetContent}
                onBeforePrint={handleBeforePrint}
                removeAfterPrint={true}
                trigger={() => (
                  <button
                    // onClick={() => console.log("dfsdfsdfd")}
                    disabled={printloading ? true : false}
                    className="btn btn-primary w-50 mx-2"
                  >
                    {printloading ? <span>Printing..</span> : "Print"}
                  </button>
                )}
                content={() => componentRef.current}
              />
            ) : null}

            <DownloadTableExcel
              filename="Challan Receive User Wise"
              sheet="Challan Receive User Wise"
              currentTableRef={exportTable.current}
            >
              {data?.length > 0 ? (
                <button className="btn btn-primary mx-2">Export</button>
              ) : null}
            </DownloadTableExcel>
          </div>
        </div>

        <br />
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner class="text-center" variant="info" animation="border" />
          </div>
        ) : null}

        {isVisible ? (
          <>
            <div id="tableboot">
              <div className="row p-3">
                <img
                  style={{ height: 120, width: 130 }}
                  src={icon}
                  alt="logo"
                />

                <div className="col-md-8">
                  <h1>{unitName}</h1>
                  <h2>Challan Received User Wise</h2>
                  {data.length > 0 ? (
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "90%",
                          marginTop: "10px",
                        }}
                      >
                        <div>
                          <h5 className="">Receving Date:- {currentDate}</h5>

                          {selectedbank != 0 ? (
                            <h5 className="">
                              Bank Category :-{" "}
                              {wholeBankCat.length && wholeBankCat[0].title}{" "}
                            </h5>
                          ) : null}
                        </div>
                        <div>
                          <h5 className="">Printing Date :- {todayDate()}</h5>
                          {selectedbank != 0 ? (
                            <h5 className="">
                              Bank:- {wholeBank.bank_name}&nbsp;&nbsp;
                              {`(${wholeBank.account_head})`}{" "}
                            </h5>
                          ) : null}
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>

              <ColoredLine color={"#FF0000"} />
              <Table responsive>
                <thead>
                  <tr id="tbl">
                    <th className="text-center">Sr No.</th>
                    <th className="text-center">User Name</th>
                    <th className="text-center">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, i) => (
                    <tr key={i} id="tbl">
                      <td style={{ color: "black" }} className="text-center">
                        {i + 1}
                      </td>
                      <td style={{ color: "black" }} className="text-center">
                        {item?.user?.office_title}
                      </td>
                      <td style={{ color: "black" }} className="text-center">
                        {Intl.NumberFormat("en-Us").format(item?.total_paid)}
                      </td>
                    </tr>
                  ))}

                  <tr id="tbl" style={{ borderBottom: "2px solid black" }}>
                    <td></td>
                    <td
                      style={{
                        color: `${config.txtColor}`,
                        fontSize: "1.4rem",
                        fontWeight: "bold",
                      }}
                    >
                      Grand Total Amount :-
                    </td>
                    <td
                      style={{
                        color: "black",
                        fontSize: "1.4rem",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      {Intl.NumberFormat("en-Us").format(grandTotalAmount)}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </>
        ) : null}
      </Paper>

      {/* For Print */}

      <div
        ref={componentRef}
        id="printSection"
        style={{ visibility: "hidden" }}
        className="tablePrint"
      >
        <div id="tableboot">
          <div className="p-3" style={{ display: "flex" }}>
            <img style={{ height: 120, width: 130 }} src={icon} alt="logo" />

            <div className="row ml-4">
              <h1>{unitName}</h1>
              <h2>Challan Received User Wise of {getMonthName(currentDate)}</h2>
              {data.length > 0 ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "90%",
                      marginTop: "10px",
                    }}
                  >
                    <div>
                      <h4 className="">Receving Date:- {currentDate}</h4>

                      {selectedbank != 0 ? (
                        <h4 className="">
                          Bank Category :-{" "}
                          {wholeBankCat.length && wholeBankCat[0].title}{" "}
                        </h4>
                      ) : null}
                    </div>
                    <div>
                      <h4 className="">Printing Date :- {todayDate()}</h4>
                      {selectedbank != 0 ? (
                        <h4 className="">
                          Bank:- {wholeBank.bank_name}&nbsp;&nbsp;
                          {`(${wholeBank.account_head})`}{" "}
                        </h4>
                      ) : null}
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </div>

          <table style={{ width: "100%" }}>
            <thead>
              <tr id="tbl">
                <th
                  className="text-center"
                  style={{
                    fontSize: "16px",
                    borderTop: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                >
                  Sr No.
                </th>
                <th
                  className="text-center"
                  style={{
                    fontSize: "16px",
                    borderTop: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                >
                  User Name
                </th>
                <th
                  className="text-center"
                  style={{
                    fontSize: "16px",
                    borderTop: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, i) => (
                <tr key={i} id="tbl">
                  <td
                    style={{ color: "black", fontSize: "16px" }}
                    className="text-center"
                  >
                    {i + 1}
                  </td>
                  <td
                    style={{ color: "black", fontSize: "16px" }}
                    className="text-center"
                  >
                    {item?.user?.office_title}
                  </td>
                  <td
                    style={{ color: "black", fontSize: "16px" }}
                    className="text-center"
                  >
                    {Intl.NumberFormat("en-Us").format(item?.total_paid)}
                  </td>
                </tr>
              ))}

              <tr id="tbl">
                <td
                  style={{
                    color: `${config.txtColor}`,
                    fontSize: "18px",
                    fontWeight: "bold",
                    borderTop: "2px solid black",
                    borderBottom: "2px solid black",
                  }}
                ></td>
                <td
                  style={{
                    color: `${config.txtColor}`,
                    fontSize: "18px",
                    fontWeight: "bold",
                    borderTop: "2px solid black",
                    borderBottom: "2px solid black",
                  }}
                >
                  Grand Total Amount :-
                </td>
                <td
                  style={{
                    color: "black",
                    fontSize: "18px",
                    fontWeight: "bold",
                    textAlign: "center",
                    borderTop: "2px solid black",
                    borderBottom: "2px solid black",
                  }}
                >
                  {Intl.NumberFormat("en-Us").format(grandTotalAmount)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* ///for exprot print */}
      <div
        ref={exportTable}
        id="printSection"
        style={{ visibility: "hidden" }}
        className="tablePrint"
      >
        <div id="tableboot">
          <div className="p-3" style={{ display: "flex" }}>
            <div className="row ml-4">
              <h1>{unitName}</h1>
              <h2>Challan Received User Wise of {getMonthName(currentDate)}</h2>
              <h5 className="ffonmt">Printing Date :- {todayDate()}</h5>
            </div>
          </div>

          <table style={{ width: "100%" }}>
            <thead>
              <tr id="tbl">
                <th className="text-end">Sr No.</th>
                <th className="text-center">User Name</th>
                <th className="text-center">Amount</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, i) => (
                <tr key={i} id="tbl">
                  <td style={{ color: "black" }} className="text-end">
                    {i + 1}
                  </td>
                  <td style={{ color: "black" }} className="text-center">
                    {item?.user?.office_title}
                  </td>
                  <td style={{ color: "black" }} className="text-center">
                    {Intl.NumberFormat("en-Us").format(item?.total_paid)}
                  </td>
                </tr>
              ))}

              <tr id="tbl" style={{ borderBottom: "2px solid black" }}>
                <td></td>
                <td
                  style={{
                    color: `${config.txtColor}`,
                    fontSize: "1.4rem",
                    fontWeight: "bold",
                  }}
                >
                  Grand Total Amount :-
                </td>
                <td
                  style={{
                    color: "black",
                    fontSize: "1.4rem",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {Intl.NumberFormat("en-Us").format(grandTotalAmount)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ChallanReceiveUserWise;

const ColoredLine = ({ color }) => (
  <hr
    style={{
      color: color,
      backgroundColor: color,
      height: 5,
    }}
  />
);
